/* Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '../../canvas-common/interfaces/component.interface';
import { TicketContainer, TICKET_CHANGE_EVENTS } from '../tickets/TicketContainer';
import { TicketComponentHelper } from './TicketComponentHelper';
import { ActualPhase, Ticket } from '@touchplan/common';
import { utils } from 'pixi.js-legacy';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { TICKET_TEXTURE_OPTIONS } from '@appPlanApplication/tickets/TICKET_TEXTURE_OPTIONS';
import { colorIsDark } from 'utils';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';

export class TicketStarted extends TicketComponentHelper implements ComponentInterface {
	constructor(canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		const ticket: Ticket = ticketContainer.getData();
		const isDarkBackground = ticket?.view?.liveRole?.view?.color
			? colorIsDark(ticket.view.liveRole.view.color)
			: false;
		super(
			isDarkBackground
				? utils.TextureCache[TICKET_TEXTURE_OPTIONS.TEXTURE_TICKET_START_WORK_LIGHT]
				: utils.TextureCache[TICKET_TEXTURE_OPTIONS.TEXTURE_TICKET_START_WORK_DARK],
			canvasAngularLand,
			ticketContainer
		);

		this.width = 90;
		this.height = ticket?.view?.height || 135;
		this.x = 0;
		this.y = 0;
		this.alpha = isDarkBackground ? 0.3 : 0.2;

		ticketContainer.on(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);

		this.onChanged(ticketContainer);
		this.eventMode = EventMode.None;
	}

	private onChanged = (ticketContainer: TicketContainer) => {
		const ticket: Ticket = ticketContainer.getData();
		this.renderable = ticket.view.actualPhase === ActualPhase.started;
	};

	public override destroy(options?) {
		this.ticket.off(TICKET_CHANGE_EVENTS.CHANGED_ISACTUALIZED, this.onChanged);
		super.destroy(options);
	}
}
